import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Typography,
  Flex,
  Grid,
  DatePicker,
  InputNumber,
  message,
} from "antd";
import { App, Select } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrUpdateBranchTransaction,
  fetchBranchTransactionList,
  fetchBranchTransactionCode,
  fetchBranchAccounts,
  fetchToBranches,
  fetchBranchAccs,
} from "../branchTransactionThunks";
import {
  setSelectedBranchTransaction,
  setIsEditBranchTransaction,
} from "../branchTransactionSlice";
import dayjs from "dayjs";
import {
  selectBranchAccounts,
  selectBranchCode,
  selectToBranches,
} from "../branchTransactionSelectors";
import {
  fetchTagGroups,
  fetchTagGroupFields,
} from "../../../store/commonThunks/lookups";
import { getAccessType } from "../../../lib/functions";
import AddNewModal from "../../../components/DropDown/AddNewModal";
import TagCreateForm from "../../Settings/Tags/components/TagCreateForm";
import { selectAuthInfo } from "../../Auth/authSelectors";
import useMigrationDate from "../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateBranchTransactionForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = useForm();

  let [access_type, access_type_set] = useState("");
  const [tagModal, setTagModal] = useState(false);

  useEffect(() => {
    const access = getAccessType("branch_tran");
    access_type_set(access);
  }, []);

  const {
    isEditBranchTransaction,
    selectedBranchTransaction,
    toBrancheAccs,
    branchTransactions,
  } = useSelector((state) => state.branchTransaction);

  const accounts = useSelector(selectBranchAccounts);
  const branchCode = useSelector(selectBranchCode);
  const lookups = useSelector((s) => s.lookups);
  const toBranches = useSelector(selectToBranches);
  const authInfo = useSelector(selectAuthInfo);


  useEffect(() => {
    if (branchCode) {
      form.setFieldsValue({ tran_code: branchCode });
    }
  }, [branchCode, form]);

  useEffect(() => {
    dispatch(fetchBranchAccounts());
    dispatch(fetchToBranches());
    dispatch(fetchTagGroups());
    dispatch(fetchTagGroupFields());
    dispatch(fetchBranchTransactionList());
  }, [dispatch]);

  useEffect(() => {
    if (!isEditBranchTransaction) {
      dispatch(fetchBranchTransactionCode());
    }
  }, [dispatch]);
  useEffect(() => {
    if (isEditBranchTransaction && selectedBranchTransaction) {
      form.setFieldsValue({
        tran_id: selectedBranchTransaction.tran_id,
        created_date: dayjs(selectedBranchTransaction.tran_date),
        from_acc_id: selectedBranchTransaction.from_acc_id,
        // to_acc_id: selectedBranchTransaction.to_acc_id,
        to_branch_id: selectedBranchTransaction.to_branch_id,
        tran_amount: Number(selectedBranchTransaction.tran_amount),
        narration: selectedBranchTransaction.narration,
        tran_code: selectedBranchTransaction.tran_code,
        tag_field_id: selectedBranchTransaction.tag_field_id
      });
dispatch(fetchBranchAccs(selectedBranchTransaction.to_branch_id))
      .unwrap()
      .then(() => {
        form.setFieldValue("to_acc_id", selectedBranchTransaction.to_acc_id);
      });

    } else {
      form.resetFields();
      form.setFieldsValue({
        created_date: dayjs(),
      });
    }
  }, [isEditBranchTransaction, selectedBranchTransaction]);

  const handleCancel = () => {
    dispatch(setSelectedBranchTransaction(null));
    dispatch(setIsEditBranchTransaction(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      if (values.from_acc_id === values.to_acc_id) {
        modal.warning({
          title: "From Account and To Branch Account cannot be the same",
        });
        return;
      }

      const payLoad = {
        tran_code: values.tran_code?.trim(),
        tran_date: values.created_date.format("YYYY-MM-DD"),
        to_branch_id: values.to_branch_id,
        from_acc_id: values.from_acc_id,
        to_acc_id: values.to_acc_id,
        tran_amount: values.tran_amount === "" ? 0 : values.tran_amount,
        narration: values.narration || "",
        tran_id: selectedBranchTransaction?.tran_id || 0,
        action: isEditBranchTransaction ? "update" : "create",
      };

      if (values.tag_field_id && values.tag_field_id !== 0) {
        payLoad.tag_field_id = values.tag_field_id;
      }

      await dispatch(createOrUpdateBranchTransaction(payLoad)).unwrap();

      modal.success({
        title: isEditBranchTransaction
          ? "Branch Transaction updated successfully"
          : "Branch Transaction created successfully",
      });

      dispatch(setSelectedBranchTransaction(null));
      dispatch(setIsEditBranchTransaction(false));
      navigate("/accounts/branch-tran");
      dispatch(fetchBranchTransactionList());
      dispatch(fetchBranchTransactionCode());
    } catch (error) {
      modal.warning({ title: error.message || "Save failed" });
    }
  };

  const handleBranchChange = async (branchId) => {
    form.setFieldValue("to_acc_id", null);
    dispatch(fetchBranchAccs(branchId));
  };
const {disabledDate} = useMigrationDate();
  return (
    <div className="branch-transaction-form">
      <Title
        level={2}
        style={{
          marginBottom: "32px",
          wordBreak: "break-word",
          fontSize: screens.md ? undefined : "20px",
        }}
      >
        {isEditBranchTransaction
          ? "Update Branch Transaction"
          : "Create New Branch Transaction"}
      </Title>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        className="responsive-form"
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
        initialValues={{ tran_code: branchCode }}
        requiredMark={(label, { required }) =>
          required ? (
            <>
              {label} <span style={{ color: "#ff4d4f" }}>*</span>
            </>
          ) : (
            label
          )
        }
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="To Branch"
              name="to_branch_id"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select Branch"
                data-testid="input-to-branch"
                options={toBranches.map((b) => ({
                  label: b.name,
                  value: b.id,
                }))}
                onChange={(value) => handleBranchChange(value)}
              />
            </Form.Item>

            <Form.Item
              label="From Account"
              name="from_acc_id"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select From Account"
                data-testid="input-from-account"
                options={accounts.map((acc) => ({
                  label: acc.acc_name,
                  value: acc.acc_id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="Transaction Date"
              name="created_date"
              rules={[{ required: true }]}
            >
              <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY"                     disabledDate={disabledDate}   />
            </Form.Item>

            <Form.Item label="Tag" name="tag_field_id">
              <Select
                mode="multiple"
                maxTagCount="responsive"
                className="tag-multiselect"
                placeholder="Select Tag(s)"
                options={lookups.tagFields.map((tag) => ({
                  label: tag.display_text,
                  value: tag.id,
                }))}
                popupRender={(menu) => (
                  <>
                    {menu}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 8,
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <Button type="link" onClick={() => setTagModal(true)}>
                        + Add New Tag
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>
          </Flex>

          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "45%" }}
          >
            <Form.Item
              label="To Branch Account"
              name="to_acc_id"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select To Branch Account"
                data-testid="input-to-branch-acc"
                options={toBrancheAccs?.map((acc) => ({
                  label: acc.acc_name,
                  value: acc.acc_id,
                }))}
              />
            </Form.Item>

            <Form.Item
              label="Amount"
              name="tran_amount"
              rules={[
                { required: true },
                { type: "number", min: 1, message: "Must be > 0" },
              ]}
            >
              <InputNumber
                data-testid="input-tran-amount"
                min={1}
                step={1} // allow decimal steps
                precision={2}
                style={{ width: "100%" }}
                onWheel={(e) => e.target.blur()}
              />
            </Form.Item>

            <Form.Item
              label="Transaction Code"
              name="tran_code"
              rules={[{ required: true }]}
            >
              <InputField disabled />
            </Form.Item>

            <Form.Item label="Description" name="narration">
              <InputField
                placeholder="Enter Description"
                data-testid="input-tran-narration"
              />
            </Form.Item>
          </Flex>
        </Flex>
        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>
          {access_type == "WRITE" && (
            <>
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="traic-button"
                data-testid="btn-save-branch-tran"
              >
                {isEditBranchTransaction ? "Update" : "Save"}
              </Button>
            </>
          )}
        </Flex>
      </Form>

      <AddNewModal
        open={tagModal}
        title="Add Tag"
        onClose={() => setTagModal(false)}
      >
        <TagCreateForm
          authInfo={authInfo}
          onSuccess={async ({ createdName }) => {
            const res = await dispatch(fetchTagGroupFields("")).unwrap();

            const match = res.find(
              (t) =>
                t?.raw?.field_name?.toLowerCase() ===
                createdName.toLowerCase()
            );

            if (!match) {
              message.warning("Tag creation failed or tag not found");
              setTagModal(false);
              return;
            }

            const current = form.getFieldValue("tag_field_id") || [];

            if (current.includes(match.id)) {
              message.info("Tag already exists and is already selected");
              setTagModal(false);
              return;
            }

            // ✅ AUTO SELECT (Form-based)
            form.setFieldsValue({
              tag_field_id: [...current, match.id],
            });

            message.success("Tag added");
            setTagModal(false);
          }}
        />
      </AddNewModal>
    </div>
  );
};

export default CreateBranchTransactionForm;
